import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import accountConstants from "../constants/accountConstants";

const addIncomeShare = (payload: any) => {
  return api.post(Endpoint.createAccount, payload);
};
const getClientTypes = () => api.get(Endpoint.getClientTypes);
const getSignupCategory = () => api.get(Endpoint.getSignupCategory);
const getClients = (payload: any) =>
  api.get(Endpoint.retrieveClients, {
    params: {
      ordering: payload.clientNameSort,
      page: payload.page,
      ...(payload.searchText && { search: payload.searchText }),
      ...(payload.clientType && { label_name: payload.clientType }),
      ...(payload.from && {
        last_payment_date_after: payload.from,
      }),
      ...(payload.to && {
        last_payment_date_before: payload.to,
      }),
    },
  });

const getAllClients = () => api.get(Endpoint.retrieveAllClients);

const editClientInfo = (payload: any) =>
  api.put(`${Endpoint.editClientInfo}/${payload.id}/`, payload.body);
const editClientFilter = (payload: any) =>
  api.put(`${Endpoint.editClientFilter}/${payload.id}/`, payload.body);
const getSingleClient = (id: string) =>
  api.get(`${Endpoint.retrieveSingleClient}/${id}/`);

const getIsClientShareExist = (payload: any) =>
  api.get(Endpoint.getIsClientShareExist, {
    params: {
      id: payload.id,
    },
  });

const getClientAdjustmentAmount = (payload: any) =>
  api.get(
    `${Endpoint.getClientAdjustmentAmount}/${payload.invoiceId}/invoice-client-adjust-mapper/`,
    {
      params: {
        page: payload.page,
      },
    },
  );

const getNoPageClientAdjAmount = (payload: any) =>
  api.get(
    `${Endpoint.getClientAdjustmentAmount}/${payload.invoiceId}/invoice-client-adjust-mapper/all/`,
  );

const paymentWithAdjustment = (payload: any) =>
  api.post(Endpoint.paymentWithAdjustment, payload);

function* createAccount(action: any) {
  try {
    const response: AxiosResponse = yield call(addIncomeShare, action.payload);
    yield put({
      type: accountConstants.ADD_ACCOUNT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: accountConstants.ADD_ACCOUNT_FAILURE, err: e });
  }
}

function* getClientTypesAsync() {
  try {
    const response: AxiosResponse = yield call(getClientTypes);
    yield put({
      type: accountConstants.GET_CLIENT_TYPES_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: accountConstants.GET_CLIENT_TYPES_FAILURE, err: e });
  }
}

function* getSignupCategoryAsync() {
  try {
    const response: AxiosResponse = yield call(getSignupCategory);
    yield put({
      type: accountConstants.GET_SIGNUP_CATEGORY_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: accountConstants.GET_SIGNUP_CATEGORY_FAILURE, err: e });
  }
}

function* getClientsAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getClients, action.payload);
    yield put({
      type: accountConstants.GET_CLIENTS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: accountConstants.GET_CLIENTS_FAILURE, err: e });
  }
}

function* getAllClientsAsync() {
  try {
    const response: AxiosResponse = yield call(getAllClients);
    yield put({
      type: accountConstants.GET_ALL_CLIENTS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: accountConstants.GET_ALL_CLIENTS_FAILURE, err: e });
  }
}

function* editClientInfoAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(editClientInfo, action.payload);
    yield put({
      type: accountConstants.EDIT_CLIENT_INFO_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: accountConstants.EDIT_CLIENT_INFO_FAILURE, err: e });
  }
}

function* editClientFilterAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      editClientFilter,
      action.payload,
    );
    yield put({
      type: accountConstants.EDIT_CLIENT_FILTER_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: accountConstants.EDIT_CLIENT_FILTER_FAILURE, err: e });
  }
}

function* getSingleClientAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getSingleClient, action.id);
    yield put({
      type: accountConstants.GET_SINGLE_CLIENT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: accountConstants.GET_SINGLE_CLIENT_FAILURE, err: e });
  }
}

function* getIsClientShareExistAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getIsClientShareExist,
      action.payload,
    );
    yield put({
      type: accountConstants.GET_IS_CLIENT_SHARE_EXIST_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: accountConstants.GET_IS_CLIENT_SHARE_EXIST_FAILURE,
      err: e,
    });
  }
}

function* getClientAdjustmentAmountAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getClientAdjustmentAmount,
      action.payload,
    );

    yield put({
      type: accountConstants.GET_CLIENT_ADJUSTMENT_AMOUNT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: accountConstants.GET_CLIENT_ADJUSTMENT_AMOUNT_FAILURE,
      err: e,
    });
  }
}

function* getNoPageClientAdjAmountAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getNoPageClientAdjAmount,
      action.payload,
    );

    yield put({
      type: accountConstants.GET_NO_PAGE_ADJUSTMENT_AMOUNT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: accountConstants.GET_NO_PAGE_ADJUSTMENT_AMOUNT_FAILURE,
      err: e,
    });
  }
}

function* paymentWithAdjustmentAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      paymentWithAdjustment,
      action.payload,
    );

    yield put({
      type: accountConstants.PAYMENT_WITH_ADJUSTMENT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: accountConstants.PAYMENT_WITH_ADJUSTMENT_FAILURE,
      err: e,
    });
  }
}

function* accountSaga() {
  yield all([takeEvery(accountConstants.ADD_ACCOUNT_REQ, createAccount)]);
  yield all([
    takeEvery(accountConstants.GET_CLIENT_TYPES_REQUEST, getClientTypesAsync),
    takeEvery(
      accountConstants.GET_SIGNUP_CATEGORY_REQUEST,
      getSignupCategoryAsync,
    ),
    takeEvery(accountConstants.GET_CLIENTS_REQUEST, getClientsAsync),
    takeEvery(accountConstants.GET_ALL_CLIENTS_REQUEST, getAllClientsAsync),
    takeEvery(accountConstants.EDIT_CLIENT_INFO_REQUEST, editClientInfoAsync),
    takeEvery(
      accountConstants.EDIT_CLIENT_FILTER_REQUEST,
      editClientFilterAsync,
    ),
    takeEvery(accountConstants.GET_SINGLE_CLIENT_REQUEST, getSingleClientAsync),
    takeEvery(
      accountConstants.GET_IS_CLIENT_SHARE_EXIST_REQUEST,
      getIsClientShareExistAsync,
    ),
  ]);
  yield all([
    takeEvery(
      accountConstants.GET_CLIENT_ADJUSTMENT_AMOUNT_REQUEST,
      getClientAdjustmentAmountAsync,
    ),
  ]);
  yield all([
    takeEvery(
      accountConstants.GET_NO_PAGE_ADJUSTMENT_AMOUNT_REQUEST,
      getNoPageClientAdjAmountAsync,
    ),
  ]);
  yield all([
    takeEvery(
      accountConstants.PAYMENT_WITH_ADJUSTMENT_REQUEST,
      paymentWithAdjustmentAsync,
    ),
  ]);
}

export default accountSaga;
